var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tabs-demo"}},[_c('tabs-default'),_c('tabs-color'),_c('tabs-alignments'),_c('tabs-position'),_c('tabs-icons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }